<template>
  <div class="lm-legend">
    <div>
      <strong>{{ $t('Webportal.CX.Margin.ColorThresholds')}} - {{ $t('Webportal.CX.Glossary') }}</strong>
    </div>

    <div  class="lm-legend-line"
          v-for="(threshold, index) in thresholds"
          :key="index">
      <div class="lm-begend-box" :style="{ 'background': `${threshold.Color}` }" />
      <div style="text-align: right;">{{ getNumericInt(threshold.Minimum.toString())}} -</div>
      <div style="text-align: right;">{{ getNumericInt(threshold.Maximum.toString()) }}%</div>
      <div>&nbsp;</div>
      <div>{{ $t('Webportal.CX.Margin.FulfillmentRealRequests') }} = {{ getValue(threshold) }}% {{ $t('Webportal.CX.Margin') }} {{ brand }} {{ getJaguarMarginTextCustom(threshold) }}</div>
      <div>&nbsp;</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    brand:              { type: String, required: false },
    isJaguarMargin2023: { type: Boolean, default: false },
    thresholds:         { type: Array, required: true }
  },

  methods: {
    getValue(threshold) {
      return this.brand == 'Jaguar' ? threshold.jag.toFixed(1) : threshold.value.toFixed(1);
    },
    
    getNumericInt(value) {
      return value.includes('.') ? value.substring(0, value.indexOf('.')) : value;
    },

    getJaguarMarginTextCustom(threshold) {
      if (!this.isJaguarMargin2023 || threshold.jag23 === 0) return '';
      return `(${this.$t('Webportal.CX.OldContract')}) / ${threshold.jag23.toFixed(1)}% ${this.$t('Webportal.CX.Margin')} ${this.brand} (${this.$t('Webportal.CX.NewContract')})`;
    }
  }
}
</script>
